import { render } from "./SavingsCard.vue?vue&type=template&id=454c7c46&scoped=true"
import script from "./SavingsCard.vue?vue&type=script&lang=js"
export * from "./SavingsCard.vue?vue&type=script&lang=js"

import "./SavingsCard.vue?vue&type=style&index=0&id=454c7c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454c7c46"]])

export default __exports__